/* Redux */
import Redux from './Drawer.Redux'

/* Material */
import Drawer from '@mui/material/Drawer'
import IconButton from '@mui/material/IconButton'
import CloseIcon from '@mui/icons-material/Close'
import useStyles from './styles'

/* Components */
import Navigation from './Navigation'

const NavigationDrawer = () => {
  const classes = useStyles()

  const { open, toggle } = Redux()

  return <Drawer
    className={classes.drawer}
    variant='temporary'
    anchor='left'
    open={open}
    onClose={toggle}
    PaperProps={{ role: 'dialog', 'aria-modal': true, 'aria-label': 'Navigation' }}
  >
    <IconButton autoFocus aria-label='Menü schließen' onClick={toggle} sx={{ alignSelf: 'flex-end', m: 1 }}>
      <CloseIcon />
    </IconButton>
    <Navigation placement='drawer' />
  </Drawer>
}

export default NavigationDrawer
